<template>
    <div class="fixed-scroller">
        <div class="v-alert" style="margin-left: 0px;left: 20px;top:70px;width:calc(100% - 40px)">
            <header><p>Wallet - <strong>{{ component.item.title }}</strong></p><div class="x" @click="$emit('emit',{ t: component.t, action: 'exit', component: component })"></div></header>
            <div style="float: left;width:calc(100% - 20px);margin:10px;min-height: 300px;border:1px solid #c0c0c0">
                <div v-for="card in wallet.cards" class="wallet-card">
                    <p>{{ card.title }}</p>
                    <Card :card="card" @editCard="$emit('editCard',card)" @setExpiry="$emit('setExpiry',card)" @removeCard="removeCardFromWallet" />
                </div>
            </div>
            <div class="btns">
                <p class="btn" @click="selectCardType = cardTypes.map(t => t)">add card</p>
            </div>
        </div>
        <div v-if="selectCardType.length > 0" class="v-alert w-600 select-card">
            <header><p>Select Card</p><div class="x" @click="selectCardType = []"></div></header>
            <select style="margin: 25px;" v-model="selectedType"><option v-for="type in selectCardType" :value="type">{{ type.title }}</option></select><p class="btn" @click="makeCopy()">new copy</p>
            <div class="btns">
                <p class="btn" @click="newCard()">select</p>
            </div>
        </div>
        <component v-if="Component" :is="Component" :item="item" @emit="emit"></component>
    </div>
</template>

<script>

import createAd from '@/components/createAd.vue';
import editVideoCard from '@/components/editVideoCard.vue'
import Card from '../components/Card.vue';
import Alert from '../utils/Alert.js'
import WebSoc from '../utils/WebSoc.js';

export default {
    props: ['component'],
    computed: {
        cards () { return this.$store.state.DB.cards }
    },
    components: {
        createAd,
        editVideoCard,
        Card
    },
    data () {
        return {
            Component: '',
            item: false,
            selectCardType: [],
            selectedType: '',
            cardTypes: [{ title: 'New Card' }],
            wallet: {
                cards: []
            }
        }
    },
    mounted () {
        var wallet = this.component.item;
            this.wallet.cards = [];
            wallet.cards.forEach((Card,i) => {
                var card = this.cards.find(c => c._id == Card._id);
                this.wallet.cards.push(card);
            });
            this.cardTypes = this.cardTypes.concat(this.cards);
            this.selectedType = this.cardTypes[0];    
    },
    methods: {
        makeWalletCards () {
            var wallet = this.component.item;
            this.wallet.cards = [];
            wallet.cards.forEach((Card,i) => {
                var card = this.cards.find(c => c._id == Card._id);
                this.wallet.cards.push(card);
            });
            this.cardTypes = this.cardTypes.concat(this.cards);
            this.selectedType = this.cardTypes[0];                
        },
        makeCopy () {
            this.selectCardType = [];
            var card = this.selectedType;
                card.copy = true;
                this.item = card;
                this.Component = 'editVideoCard';
        },
        newCard () {

            this.selectCardType = [];
            var card = this.selectedType;
            if ( card._id ) return this.$emit('addCardToWallet',{ card, wallet: this.component.item });
            this.item = false;
            this.Component = 'editVideoCard';
            
        },
        addCardToWallet ( card ) {
            var wallet = this.component.item;
            WebSoc.SEND('update',{ DB: 'wallets', _id: wallet._id, update: { $push: { cards: { _id: card._id } }}},() => {
                console.log('added to wallet');
                var length = wallet.cards.length;
                console.log('wallet.cards.length',wallet.cards.length);
                 var interval = setInterval(() => {
                    console.log('wallet.cards.length',wallet.cards.length);
                    if ( length != wallet.cards.length ) {
                        clearInterval(interval);
                        this.makeWalletCards();
                    }
                },1000)
            })
        },
        removeCardFromWallet ( card ) {
            var wallet = this.component.item;
            console.log('removeCardFromWallet',card.title);
            Alert.yesno('Remove<br>'+card.title+'<br>from<br>'+wallet.title+'?',yes => {
                if ( !yes ) return;
                
                WebSoc.SEND('update',{ DB: 'wallets', _id: wallet._id, update: { $pull: { cards: { _id: card._id } }}},() => {
                    var wallet = this.wallet;
                    console.log('removed',card._id);
                    console.log('before wallet.cards.length',wallet.cards.length);
                    wallet.cards = wallet.cards.filter(c => c._id != card._id);
                    console.log('after wallet.cards.length',wallet.cards.length);
                    this.$forceUpdate();
                })
            })
        },
        emit ( data ) {
            switch ( data.action ) {
                case 'exit':
                    this.Component = false;
                    return;
                case 'add-card':
                    this.Component = false;
                    return this.addCardToWallet(data.ad);    
            }
           
            console.log('emit data',data);
        }
    }
}

</script>

<style lang="scss">
.wallet-card {
    float: left;
    border: 1px solid #c0c0c0;
    margin: 10px;
    > p { font-weight: bold; margin: 5px 10px 0px 10px; font-size: 18px; }
}    
.select-card {
    select {
        float: left;
        width: 420px;
        + p.btn {
            float: left;
            margin-top: 25px;
        }
    }
}
</style>